import axios from 'axios'

/** Extract DRF-style `detail` from an axios error, falling back to `fallback`. */
export function getApiErrorDetail(err: unknown, fallback: string): string {
  if (!axios.isAxiosError(err)) {
    return fallback
  }
  const detail = err.response?.data?.detail
  return typeof detail === 'string' && detail.length > 0 ? detail : fallback
}

/**
 * Best-effort human-readable message from an axios error — for toasts on
 * partial-update saves where the failure is usually a field validation error.
 * Handles the three DRF shapes: a bare string body, `{ detail: "…" }`, and
 * field-keyed errors like `{ url: ["Enter a valid URL."] }` (returns the first
 * such message). Falls back to `fallback` when nothing usable is found.
 */
export function getApiErrorMessage(err: unknown, fallback: string): string {
  if (!axios.isAxiosError(err)) {
    return fallback
  }
  const data = err.response?.data
  if (typeof data === 'string' && data.length > 0) {
    return data
  }
  if (data && typeof data === 'object') {
    const detail = (data as Record<string, unknown>).detail
    if (typeof detail === 'string' && detail.length > 0) {
      return detail
    }
    for (const value of Object.values(data)) {
      if (typeof value === 'string' && value.length > 0) {
        return value
      }
      if (
        Array.isArray(value) &&
        typeof value[0] === 'string' &&
        value[0].length > 0
      ) {
        return value[0]
      }
    }
  }
  return fallback
}
